var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArabiska = function SvgArabiska(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 18 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00263E",
    strokeWidth: 1.5,
    d: "M6.9 15.8 9 13.6h5c1.8 0 3.3-1.5 3.3-3.3V4c0-1.8-1.5-3.3-3.3-3.3H4C2.2.8.8 2.2.8 4v6.4c0 1.8 1.5 3.3 3.3 3.3h2.5v1.9c0 .1.1.3.2.3 0-.1.1-.1.1-.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00263E",
    d: "M5.6 8.5H3.9l-.3 1h-1l1.8-4.7h.9l1.8 4.7h-1zm-1.5-.8h1.2l-.6-1.8zM9.1 7.7h-.8v1.7h-1V4.7h1.8c.6 0 1 .1 1.3.4.3.2.5.6.5 1.1 0 .3-.1.6-.2.8s-.3.4-.6.5l1 1.9h-1zm-.8-.8h.8c.2 0 .4-.1.6-.2.1-.1.2-.3.2-.5s-.1-.4-.2-.5-.3-.2-.6-.2h-.8zM14.3 8.5h-1.7l-.3 1h-1L13 4.7h.9l1.8 4.7h-1zm-1.5-.8H14l-.6-1.8z"
  })));
};
export default SvgArabiska;